import { InvestmentsServicesInsightsPage } from "@nvb/ui";
import { usePageContext } from "vike-react/usePageContext";

import type { NewsItem, NewsResponse } from "@nvb/ui";

/**
 * Both article lists came from a browser-only fetch, so the prerendered HTML
 * held nothing but the loading state. The build-time snapshots travel in
 * `pageContext.initialData` (see `pages/+onBeforeRender.ts`) and seed the two
 * `useNews` hooks; both still refetch on mount and walk the remaining pages.
 */
export default function Page() {
	const { initialData } = usePageContext();

	const macroeconomics = (initialData?.newsMacroeconomics as NewsResponse | undefined)?.data;
	const publicCompanies = (initialData?.newsPublicCompanies as NewsResponse | undefined)?.data;

	return (
		<InvestmentsServicesInsightsPage
			{...(macroeconomics?.length ? { initialMacroeconomics: macroeconomics as NewsItem[] } : {})}
			{...(publicCompanies?.length ? { initialPublicCompanies: publicCompanies as NewsItem[] } : {})}
		/>
	);
}
